// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a.try-mdh {
    max-width: 100%;
    text-decoration: none;
    display: flex;
    background: var(--ce-blue-vivid-5);
    align-items: center;
    padding: 13px 15px;
    border-radius: var(--border_radius_lg);
    margin: 20px auto;
    cursor: pointer;
    color: var(--ce-blue-70);
    width: 460px;
}
@media (min-width: 576px) {
    a.try-mdh {
        margin-top: 40px;
    }
}

.try-mdh-logo {
    padding-right: 10px;
}
.try-mdh-message {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.try-mdh-message span {
    font-size: 14px;
    padding-top: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Coordinator/TryMDH.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;IACtC,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,YAAY;AAChB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["a.try-mdh {\n    max-width: 100%;\n    text-decoration: none;\n    display: flex;\n    background: var(--ce-blue-vivid-5);\n    align-items: center;\n    padding: 13px 15px;\n    border-radius: var(--border_radius_lg);\n    margin: 20px auto;\n    cursor: pointer;\n    color: var(--ce-blue-70);\n    width: 460px;\n}\n@media (min-width: 576px) {\n    a.try-mdh {\n        margin-top: 40px;\n    }\n}\n\n.try-mdh-logo {\n    padding-right: 10px;\n}\n.try-mdh-message {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.try-mdh-message span {\n    font-size: 14px;\n    padding-top: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
